import React from 'react'
import '../../index.scss'
import Logo from '../../icons/logo.png'
import Export from '../../icons/export.png'
import appData from '../../data'
import Column from '../../column.jsx'
import { DragDropContext } from 'react-beautiful-dnd'
import swal from '@sweetalert/with-react'
import { v4 as uuidv4 } from 'uuid'
import SubscriptionExpired from '../subscription/SubscriptionExpired'

import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonNext,
  ButtonBack,
  DotGroup,
} from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'

import roomTable from '../../room-table.js'

import styled from 'styled-components'

import { db, auth } from '../../firebase.js'

var crypto = require('crypto')

const Container = styled.div`
  display: flex;
`

class Room extends React.Component {
  state = appData

  constructor() {
    super()

    this.onCardFlip = this.onCardFlip.bind(this)
    this.resetCards = this.resetCards.bind(this)
    this.isRoomActive = this.isRoomActive.bind(this)
    this.checkSubscription = this.checkSubscription.bind(this)
    this.isSubscriptionActive = this.isSubscriptionActive.bind(this)
    this.checkKey = this.checkKey.bind(this)
    this.showInstructions = this.showInstructions.bind(this)
    this.carouselNext = this.carouselNext.bind(this)
    this.updateRoomName = this.updateRoomName.bind(this)
    this.saveRoomName = this.saveRoomName.bind(this)
    this.updateUserActive = this.updateUserActive.bind(this)
    this.resetAllCards = this.resetAllCards.bind(this)
    this.onColumnStack = this.onColumnStack.bind(this)
    this.handleMouseUp = this.handleMouseUp.bind(this)
  }

  maybePluralize = (count, noun, suffix = 's') => {
    return `${count} ${noun}${count !== 1 ? suffix : ''}`
  }

  onDragStart = (result) => {
    const { draggableId } = result

    const newState = {
      ...this.state,
      cardBeingDragged: true,
      cards: {
        ...this.state.cards,
        [draggableId]: {
          ...this.state.cards[draggableId],
          isBeingDragged: true,
        },
      },
    }

    db.ref(this.getRoomName()).set(newState)
    this.setState(newState)
  }

  onDragEnd = (result) => {
    const { destination, source, draggableId } = result

    if (!destination) {
      const newState = {
        ...this.state,
        cardBeingDragged: false,
        cards: {
          ...this.state.cards,
          [draggableId]: {
            ...this.state.cards[draggableId],
            isBeingDragged: false,
          },
        },
      }

      db.ref(this.getRoomName()).set(newState)
      this.setState(newState)
      return
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      const newState = {
        ...this.state,
        cardBeingDragged: false,
        cards: {
          ...this.state.cards,
          [draggableId]: {
            ...this.state.cards[draggableId],
            isBeingDragged: false,
          },
        },
      }

      db.ref(this.getRoomName()).set(newState)
      this.setState(newState)
      return
    }

    const start = this.state.columns[source.droppableId]
    const finish = this.state.columns[destination.droppableId]

    if (start === finish) {
      const newCardIds = Array.from(start.cardIds)
      newCardIds.splice(source.index, 1)
      newCardIds.splice(destination.index, 0, draggableId)

      const newColumn = {
        ...start,
        cardIds: newCardIds,
      }

      const newState = {
        ...this.state,
        cardBeingDragged: false,
        columns: {
          ...this.state.columns,
          [newColumn.id]: newColumn,
        },
        cards: {
          ...this.state.cards,
          [draggableId]: {
            ...this.state.cards[draggableId],
            isBeingDragged: false,
          },
        },
      }

      db.ref(this.getRoomName()).set(newState)
      this.setState(newState)

      return
    }

    const startCardIds = Array.from(start.cardIds)
    startCardIds.splice(source.index, 1)
    const newStart = {
      ...start,
      cardIds: startCardIds,
    }

    const finishCardIds = Array.from(finish.cardIds)
    finishCardIds.splice(destination.index, 0, draggableId)
    const newFinish = {
      ...finish,
      cardIds: finishCardIds,
    }

    const newState = {
      ...this.state,
      cardBeingDragged: false,
      columns: {
        ...this.state.columns,
        [newStart.id]: newStart,
        [newFinish.id]: newFinish,
      },
      cards: {
        ...this.state.cards,
        [draggableId]: {
          ...this.state.cards[draggableId],
          isBeingDragged: false,
        },
      },
    }

    var newColumn = destination.droppableId

    for (const property in newState.columns) {
      if (property === newColumn || property === 'start') {
        continue
      }

      newState.columns[property].cardIds = newState.columns[
        property
      ].cardIds.filter(function (value, index, arr) {
        return value !== draggableId
      })
    }

    db.ref(this.getRoomName()).set(newState)
    this.setState(newState)
  }

  componentWillUnmount() {
    clearInterval(this.updateUserActivity)
  }

  // Check if string is email so we dont pass bad requests to Stripe API
  isEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      )
  }

  async isSubscriptionActive(obj) {
    let customerId = obj.customer_id

    if (customerId === undefined || this.isEmail(customerId)) {
      const url = `https://api.stripe.com/v1/customers?email=${obj.owner_email}&limit=10`

      const options = {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_LIVE}`,
        },
      }

      const response = await fetch(url, options)

      const json = await response.json()

      if (json.data[0]) {
        customerId = await json.data[0].id

        this.setState({ StripeCustomerId: customerId })
      } else {
        console.log('no cust id')
        return true
      }
    } else {
      this.setState({ StripeCustomerId: customerId })
    }

    const url = `https://api.stripe.com/v1/subscriptions?customer=${customerId}&status=all`
    const options = {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_LIVE}`,
      },
    }

    const response = await fetch(url, options)
    //initialize varible to hold our data from the API
    var subscription
    // if customer id isn't in stripe then return false
    if (response.ok === false) {
      subscription = false
    } else {
      const json = await response.json()
      // store our subscription in variable
      subscription = json.data[0]
    }

    // if subscription is found then format the data so we can populate our table
    if (subscription) {
      if (subscription.ended_at == null) {
        return true
      } else {
        return false
      }
    } else {
      console.log('no sub found')
      return false
    }
  }

  async checkSubscription() {
    const json = require('../../../rooms.json')

    let room = json.find((el) => el.room_name === this.getRoomName())

    const isSubActive = await this.isSubscriptionActive(room)

    if (isSubActive === true) {
      this.setState({ activeSubscription: true })
    } else {
      this.setState({ activeSubscription: false })
    }
  }

  componentDidMount() {
    var app = this
    setTimeout(function () {
      try {
        app.checkSubscription()
      } catch (error) {
        console.log(error)
      }
    }, 3000)

    this.shuffle(this.state.columns.start.cardIds)

    for (const cardId in this.state.cards) {
      if (Math.random() < 0.5) {
        this.state.cards[cardId].flipped = true
      }
    }

    auth.signInAnonymously().catch(function (error) {
      var errorMessage = error.message

      console.log('Auth error')
      console.log(errorMessage)
    })

    auth
      .onAuthStateChanged(function (user) {
        if (user) {
          let ref = db.ref(app.getRoomName())
          ref.on('value', (snapshot) => {
            const state = snapshot.val()
            app.setState(state, app.activeUserInterval)
          })
        }
      })
      .bind(this)

    document.addEventListener('scroll', () => {
      if (window.scrollY >= 65) {
        document.body.classList.add('sticky-cards')
      } else {
        document.body.classList.remove('sticky-cards')
      }
    })

    if ('true' === localStorage.getItem('card-flip-tooltip')) {
      document.body.classList.add('hide-flip-tooltip')
    }
  }

  activeUserInterval() {
    if (!this.updateUserActivity) {
      this.updateUserActive()
      this.updateUserActivity = setInterval(this.updateUserActive, 5000)
    }
  }

  updateUserActive() {
    var userID = localStorage.getItem('clientID')
      ? localStorage.getItem('clientID')
      : uuidv4()
    localStorage.setItem('clientID', userID)

    const newState = {
      ...this.state,
      users: {
        ...this.state.users,
        [userID]: {
          lastSeen: Date.now(),
        },
      },
    }

    db.ref(this.getRoomName()).set(newState)

    this.setState(newState)

    var activeUsers = 0

    for (const userID in newState.users) {
      if (newState.users[userID].lastSeen > Date.now() - 10000) {
        activeUsers += 1
      }
    }

    this.activeUsers = activeUsers
  }

  onColumnStack(columnId) {
    if (
      !this.state.columns[columnId].compact ||
      this.state.columns[columnId].compact === 'spread'
    ) {
      const newState = {
        ...this.state,
        columns: {
          ...this.state.columns,
          [columnId]: {
            ...this.state.columns[columnId],
            compact: 'compact',
          },
        },
      }

      db.ref(this.getRoomName()).set(newState)
      this.setState(newState)
    } else if (this.state.columns[columnId].compact === 'compact') {
      const newState = {
        ...this.state,
        columns: {
          ...this.state.columns,
          [columnId]: {
            ...this.state.columns[columnId],
            compact: 'stacked',
          },
        },
      }

      db.ref(this.getRoomName()).set(newState)
      this.setState(newState)
    } else {
      const newState = {
        ...this.state,
        columns: {
          ...this.state.columns,
          [columnId]: {
            ...this.state.columns[columnId],
            compact: 'spread',
          },
        },
      }

      db.ref(this.getRoomName()).set(newState)
      this.setState(newState)
    }
  }

  onCardFlip(cardId) {
    if (this.state.cards[cardId].isBeingDragged) {
      return
    }

    const newState = {
      ...this.state,
      cards: {
        ...this.state.cards,
        [cardId]: {
          ...this.state.cards[cardId],
          flipped: !this.state.cards[cardId].flipped,
        },
      },
    }

    db.ref(this.getRoomName()).set(newState)
    this.setState(newState)
  }

  getRooms() {}

  getRoomName() {
    const roomName = window.location.pathname
      .split('/')
      .filter(function (el) {
        return el !== ''
      })
      .pop()

    return roomName ? roomName : 'local'
  }

  shuffle(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex -= 1

      // And swap it with the current element.
      temporaryValue = array[currentIndex]
      array[currentIndex] = array[randomIndex]
      array[randomIndex] = temporaryValue
    }

    return array
  }

  resetCards() {
    swal({
      button: false,
      content: (
        <div>
          <div className="swal-title">Are you sure?</div>
          <div className="swal-text">
            Resetting the room will put all cards back in their starting stack.
            There is no undo.
          </div>

          <div className="swal-footer">
            <div className="swal-button-container">
              <button
                className="swal-button swal-button--cancel"
                onClick={() => swal.close()}
              >
                Cancel
              </button>
              <button
                className="swal-button swal-button--confirm"
                onClick={() => this.resetAllCards()}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      ),
    })
  }

  resetAllCards() {
    const newState = appData

    this.shuffle(newState.columns.start.cardIds)

    for (const cardId in newState.cards) {
      if (Math.random() < 0.5) {
        newState.cards[cardId].flipped = true
      }
    }

    newState.lastLogin = this.state.lastLogin

    db.ref(this.getRoomName()).set(newState)
    this.setState(newState)
    swal.close()
  }

  carouselNext() {
    if (this.state.slideIndex) {
      var newState = {
        ...this.state,
        slideIndex: this.state.slideIndex + 1,
      }
    } else {
      newState = {
        ...this.state,
        slideIndex: 1,
      }
    }

    db.ref(this.getRoomName()).set(newState)
    this.setState(newState)
  }

  showInstructions() {
    swal({
      button: false,
      content: (
        <div className="instruction-modal">
          <button
            type="button"
            className="modalClose"
            onClick={() => swal.close()}
          >
            &times;
          </button>
          <CarouselProvider
            naturalSlideWidth={100}
            naturalSlideHeight={225}
            totalSlides={6}
          >
            <Slider>
              <Slide index={0}>
                <p>
                  <b>Welcome</b>
                </p>
                <p className="colfax-web-light">
                  Hey there and welcome to the digital version of Brand Deck,
                  our tool to help you understand your brand’s core
                  characteristics.
                  <br />
                  <br />
                  We’ve specifically designed this version to be easily shared
                  with friends, colleagues, and clients to collaborate remotely
                  in real time. We imagine you using this it alongside a phone
                  call or your favorite video conferencing platform.
                  <br />
                  <br />
                  We’re early in this process and will be rolling out new
                  features as we go, but in the meantime we’d love to hear any
                  feedback, comments, or questions you might have. Send us a
                  note at{' '}
                  <a href="mailto:digital@branding.cards">
                    digital@branding.cards
                  </a>
                  .
                </p>
              </Slide>
              <Slide index={1}>
                <p>
                  <b>Instructions</b>
                </p>
                <p className="colfax-web-light">
                  This exercise will help you identify your brand’s core
                  characteristics. To play, share the link to this room with a
                  few people who understand your brand best. As a group, flip
                  through the cards and sort them into the different piles (
                  <em>You Are</em>, <em>You Are Not</em>, <em>Torn</em>, and{' '}
                  <em>Does Not Apply</em>), discussing and debating the choices
                  along the way. Once all of the cards have been placed in the
                  piles, focus on the <em>You Are</em> pile and narrow it down
                  to 1 - 6 cards — these will be your brand’s attributes.
                  <br />
                  <br />
                  Click through this modal to see what the cards in each pile
                  should represent.
                </p>
              </Slide>
              <Slide index={2}>
                <p>
                  <b>You Are</b>
                </p>
                <p className="colfax-web-light">
                  The cards in this pile describe how you want to be perceived
                  by others.
                  <br />
                  <br />
                  They do not necessarily need to describe who you are today,
                  but rather who you imagine becoming.
                  <br />
                  <br />
                  It’s best to start wide and refine.
                </p>
              </Slide>
              <Slide index={3}>
                <p>
                  <b>You Are Not</b>
                </p>
                <p className="colfax-web-light">
                  The cards in this pile describe how you do not want to be
                  perceived by others.
                  <br />
                  <br />
                  They do not necessarily need to describe what you’re not today
                  but rather how you may not want to be perceived tomorrow.
                  <br />
                  <br />
                  It’s best to start wide and refine.
                </p>
              </Slide>
              <Slide index={4}>
                <p>
                  <b>Torn?</b>
                </p>
                <p className="colfax-web-light">
                  The cards in this pile represent the difficult decisions,
                  cards where both sides describe how you want to be perceived.
                  <br />
                  <br />
                  There should be very few of these cards. Communicating you are
                  both can be a challenge.
                  <br />
                  <br />
                  Choose these cards carefully.
                </p>
              </Slide>
              <Slide index={5}>
                <p>
                  <b>Does Not Apply</b>
                </p>
                <p className="colfax-web-light">
                  Neither side of the cards in this pile describe how you hope
                  to be perceived by others.
                  <br />
                  <br />
                  You want this pile to be the largest.
                </p>
              </Slide>
            </Slider>
            <DotGroup />
            <div className="buttonRow">
              <ButtonBack className="swal-button">Back</ButtonBack>
              <ButtonNext className="swal-button">Next</ButtonNext>
              <button
                className="swal-button swal-button--confirm"
                onClick={() => swal.close()}
              >
                Let's go.
              </button>
            </div>
          </CarouselProvider>
        </div>
      ),
    })
  }

  isRoomActive() {
    const currentTime = new Date().getTime()
    const twentyfourHours = 60 * 60 * 24 * 1000

    if (
      !this.state.lastLogin || currentTime - this.state.lastLogin > twentyfourHours 
    ) {
      return false
    }

    return true
  }

  checkKey(event) {
    const hash = crypto
      .createHash('md5')
      .update(event.target.value)
      .digest('hex')
    const roomName = this.getRoomName()

    if (hash === roomTable[roomName]) {
      const newState = {
        ...this.state,
        locked: false,
        lastLogin: new Date().getTime(),
      }
      db.ref(roomName).set(newState)
      this.setState(newState)
    }
  }

  saveRoomName(newName) {
    const roomName = this.getRoomName()

    const newState = {
      ...this.state,
      roomDisplayName: newName,
    }
    db.ref(roomName).set(newState)
    this.setState(newState, function () {
      var el = document.getElementById('room-display-name')
      var range = document.createRange()
      var sel = window.getSelection()

      range.setStart(el.childNodes[0], el.textContent.length)
      range.collapse(true)

      sel.removeAllRanges()
      sel.addRange(range)
    })
  }

  updateRoomName(newName) {
    clearTimeout(window.updateRoomName)

    var app = this

    window.updateRoomName = setTimeout(function () {
      app.saveRoomName(newName)
    }, 1000)
  }

  keyPress(event) {
    if (event.which === 13) {
      event.preventDefault()
      event.target.blur()
      window.getSelection().removeAllRanges()
    }

    if (
      event.which !== 8 &&
      document.getElementById('room-display-name').textContent.length >= 40
    ) {
      document.querySelector('.room-too-long').classList.add('visible')

      event.preventDefault()
      return false
    }

    document.querySelector('.room-too-long').classList.remove('visible')
  }

  handleMouseUp(event) {
    let updated_cards = this.state.cards

    for (const [key, value] of Object.entries(updated_cards)) {
      value.isBeingDragged = false

      updated_cards[key] = value
    }

    const newState = {
      ...this.state,
      cardBeingDragged: false,
      cards: updated_cards,
    }

    db.ref(this.getRoomName()).set(newState)
    this.setState(newState)
  }

  exportBoardButton() {
    swal({
      button: false,
      content: (
        <div>
          <div className="swal-title">Download</div>
          <div className="swal-text">
            You are about to download a PDF snapshot of the room.
          </div>

          <div className="swal-footer">
            <div className="swal-button-container">
              <button
                className="swal-button swal-button--cancel"
                onClick={() => swal.close()}
              >
                Cancel
              </button>
              <button
                className="swal-button swal-button--confirm"
                onClick={() => this.exportBoard()}
              >
                Download
              </button>
            </div>
          </div>
        </div>
      ),
    })
  }

  exportBoard() {
    document.body.classList.add('export-in-progress')
    document.body.classList.add('flatten-cards')

    window.tempColumnState = this.state.columns['does-not-apply'].compact
      ? this.state.columns['does-not-apply'].compact
      : 'spread'

    const newState = {
      ...this.state,
      columns: {
        ...this.state.columns,
        ['does-not-apply']: {
          ...this.state.columns['does-not-apply'],
          compact: 'stacked',
        },
      },
    }

    db.ref(this.getRoomName()).set(newState)
    this.setState(newState, () => {
      const input = document.getElementById('area-to-print')
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL('image/png')

        const pdf = new jsPDF({
          orientation: 'l', // landscape
          unit: 'pt', // points, pixels won't work properly
          format: [canvas.width, canvas.height], // set needed dimensions for any element
        })
        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height)

        let filename = this.state.roomDisplayName
          ? this.state.roomDisplayName
          : 'Untitled Room'
        filename = filename + '.pdf'
        pdf.save(filename)

        const newState = {
          ...this.state,
          columns: {
            ...this.state.columns,
            ['does-not-apply']: {
              ...this.state.columns['does-not-apply'],
              compact: window.tempColumnState,
            },
          },
        }

        db.ref(this.getRoomName()).set(newState)
        this.setState(newState)

        document.body.classList.remove('flatten-cards')

        setTimeout(function () {
          document.body.classList.remove('export-in-progress')
        }, 500)
      })
    })
    swal.close()
  }

  render() {
    return (
      <div>
        <div className="export-spinner">
          <div className="container">
            <div className="loader">Loading...</div>
            <h2>Download in progress...</h2>
          </div>
        </div>
        <div id='area-to-print' className='app'>
          {!this.isRoomActive() && (
            <div className='login-wall'>
              <div className='login-wall-inner'>
                <img className='logo' src={Logo} alt='Brand Deck Logo' />
                <p>
                  If you are the host, please enter the key to unlock this room.
                </p>

                <input type="text" onChange={this.checkKey} />
              </div>
            </div>
          )}

          {this.isRoomActive() && this.state.activeSubscription === false && (
            <>
              <SubscriptionExpired customerId={this.state.StripeCustomerId} />
            </>
          )}

          {this.isRoomActive() &&
            this.state.activeSubscription === true &&
            this.state.locked === false && (
              <div onMouseUp={this.handleMouseUp}>
                <header>
                  <div className="room-info">
                    {this.state.roomDisplayName && (
                      <p>
                        <span
                          id="room-display-name"
                          className="editable-room-title tooltip-bottom"
                          data-tooltip="Rename"
                          contentEditable="true"
                          onInput={(e) =>
                            this.updateRoomName(e.currentTarget.textContent)
                          }
                          onKeyDown={this.keyPress.bind(this)}
                          suppressContentEditableWarning={true}
                        >
                          {this.state.roomDisplayName}
                        </span>
                      </p>
                    )}

                    {!this.state.roomDisplayName && (
                      <p>
                        <span
                          id="room-display-name"
                          className="editable-room-title tooltip-bottom"
                          data-tooltip="Rename"
                          contentEditable="true"
                          onInput={(e) =>
                            this.updateRoomName(e.currentTarget.textContent)
                          }
                          onKeyDown={this.keyPress.bind(this)}
                          suppressContentEditableWarning={true}
                        >
                          Untitled Room
                        </span>
                        {!this.state.roomDisplayName}
                      </p>
                    )}
                    <p className="room-count">
                      {this.maybePluralize(this.activeUsers, 'Participant')}
                    </p>
                    <p className="room-too-long">
                      Please choose a room name less than 40 characters.
                    </p>
                  </div>
                  <div>
                    <button
                      className="download-button"
                      onClick={this.exportBoardButton.bind(this)}
                    >
                      <img
                        className="download-icon"
                        src={Export}
                        alt="Download Board"
                      />
                    </button>
                    <button onClick={this.showInstructions}>
                      Instructions
                    </button>
                    <button onClick={this.resetCards.bind(this)}>Reset</button>
                  </div>
                </header>
                <DragDropContext
                  onDragEnd={this.onDragEnd}
                  onDragStart={this.onDragStart}
                >
                  <Container>
                    {this.state.columnOrder.map((columnId) => {
                      const column = this.state.columns[columnId]
                      if (!column.cardIds) {
                        column.cardIds = []
                      }

                      var cards = column.cardIds.map(
                        (cardId) => this.state.cards[cardId],
                      )
                      let columnStack = ''
                      if ('start' === columnId) {
                        columnStack = 'stacked'
                      } else if (this.state.columns[columnId].compact) {
                        columnStack = this.state.columns[columnId].compact
                      } else {
                        columnStack = 'spread'
                      }
                      return (
                        <Column
                          key={column.id}
                          column={column}
                          cards={cards}
                          onCardFlip={this.onCardFlip}
                          onColumnStack={this.onColumnStack}
                          compact={columnStack}
                          cardIsBeingDragged={this.state.cardBeingDragged}
                        />
                      )
                    })}
                  </Container>
                </DragDropContext>
                <footer>
                  <a href="https://branding.cards">
                    <img className="logo" src={Logo} alt="Brand Deck Logo" />
                  </a>
                  <a
                    href="https://branding.cards/products/brand-deck-standard"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Get The Deck
                  </a>
                </footer>
              </div>
            )}
        </div>
        <div className="mobile-roadblock">
          <div className="mobile-roadblock-inner">
            <img className="logo" src={Logo} alt="Brand Deck Logo" />

            <p>At the moment, this experience is best suited for desktop.</p>
          </div>
        </div>
      </div>
    )
  }
}

export default Room
